const routes = [
  {
    path: '/sistema/monitoramento-servidor',
    name: 'serverMonitoring',
    component: () => import('@/views/sistema/monitoramento/MonitoramentoServidor.vue'),
    meta: {
      breadcrumb: [{ title: 'Fundação' }, { title: 'Monitoramento do Servidor' }],
    },
  },
]

export default routes
